const id = (value: string): string => encodeURIComponent(value);

export const USER_CENTER_ENDPOINTS = {
  TREE: '/v2/permissions/tree',
  TEMPLATES: '/v2/role-templates',
  PERMISSION_TEMPLATES: '/v2/permissions/templates',

  PEOPLE: '/v2/access',
  ASSIGNABLE: '/v2/access/assignable',
  PERSON: (userId: string) => `/v2/access/${id(userId)}`,
  PREVIEW: (userId: string) => `/v2/access/${id(userId)}/preview`,
  INVITE: (userId: string) => `/v2/access/${id(userId)}/invite`,
  ROLE: (userId: string) => `/v2/access/${id(userId)}/role`,
  PLANTS: (userId: string) => `/v2/access/${id(userId)}/plants`,
  PLANT: (userId: string, plantId: string) => `/v2/access/${id(userId)}/plants/${id(plantId)}`,
  OVERRIDES_BATCH: (userId: string) => `/v2/access/${id(userId)}/overrides/batch`,
  GRANT: (userId: string) => `/v2/access/${id(userId)}/grant`,
  EXCEPTIONS: (userId: string) => `/v2/access/${id(userId)}/exceptions`,
  EXCEPTION: (userId: string, grantId: string) => `/v2/access/${id(userId)}/exceptions/${id(grantId)}`,

  LICENCES: '/v2/licences',
  LICENCE: (plantId: string) => `/v2/licences/${id(plantId)}`,
  CLUSTERS: '/v2/clusters',
  LICENCE_PREVIEW: (plantId: string) => `/v2/licences/${id(plantId)}/preview`,
  LICENCE_SEED: (plantId: string) => `/v2/licences/${id(plantId)}/seed`,

  AUDIT: '/v2/audit',
  AUDIT_PLANTS: '/v2/audit/plants',
} as const;
